// extracted by mini-css-extract-plugin
export default {"container":"InfoBanner_container__1kQE8","close":"InfoBanner_close__b7u5b"};